<script>
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import SquareButton from "../../content/common/squareButton.vue";

    export default {
        name: "client-imageupload",
        components: {SquareButton, DialogButton},
        props: {
            title: {
                type: String,
                required: true
            },
            imagePath: String,
            imageName: {
                type: String,
                default: 'Image'
            }
        },
        computed: {
            translations() {
                return {
                    noPicture: Lang.langGet("No picture uploaded."),
                    uploadPicture: Lang.langGet("Upload Picture"),
                    deletePicture: Lang.langGet("Delete Picture"),
                }
            },
            projectId() {
                return Laravel.activeProject;
            },
            imageIsBase64() {
                if (this.imagePath.startsWith('data:image/png;base64')) return true;
                if (this.imagePath.startsWith('data:image/jpeg;base64')) return true;

                // do we support other file endings?
                return false;
            },
            imageSource() {
                return this.imageIsBase64 ? this.imagePath : `/storage/fields/${this.projectId}/${this.imagePath}`;
            }
        },
        methods: {
            handleUpload(event) {
                const files = event.target.files || event.dataTransfer.files;
                if (!files.length) return;

                const reader = new FileReader();
                reader.onload = e => {
                    this.$emit('upload', e.target.result);
                };
                reader.readAsDataURL(files[0]);
            }
        }
    }
</script>

<template>
    <div class="client-dialog-location-image">
        <div class="px-4">{{title}}</div>
        <div v-if="imagePath"
             class="d-flex location-image-container elevation-2-inset align-center justify-center flex-column py-4 mx-4"
             style="background-color: #e5e5e5;"
        >
            <img
                class="location-image"
                :alt="imageName"
                :src="imageSource"
            />
        </div>
        <div v-else>
            <div
                class="location-image-container elevation-2-inset d-flex justify-center align-center py-4 mx-4"
                style="background-color: #e5e5e5; font-size: 1.2rem"
            >
                {{translations.noPicture}}
            </div>
        </div>
        <div v-if="imagePath" class="delete-icon">
            <square-button
                flat
                :tooltip-text="translations.deletePicture"
                icon="far fa-trash"
                @click="$emit('delete')"
            />
        </div>
        <div class="d-flex flex-row w-100">
            <div class="flex-grow-1 pa-4">
                <dialog-button class="w-100 pa-0" color="secondary">
                    <label class="cursor-pointer font-weight-regular w-100">
                        {{translations.uploadPicture}}
                        <input class="hidden"
                           :title="translations.uploadPicture"
                           ref="upload"
                           accept="image/jpeg,image/png"
                           name="location_plan" type="file"
                           @change="handleUpload"
                        >
                    </label>
                </dialog-button>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .location-image-container {
        height: 20vh;
        border-radius: 8px;
    }
    .location-image {
        height: 18vh;
        max-width: 100%;
        border-radius: 8px;
    }
    .delete-icon {
        position: absolute;
        bottom: 74px;
        right: 24px;
    }
    .client-dialog-location-image {
        position: relative;
    }
</style>
